namespace $.$$ {

	export class $shm_projects_configuration extends $.$shm_projects_configuration {

		project() {
			const project = this.$.$shm_projects_data.detail( this.project_id() )
			if( !project ) throw new Error( `Unknown project: ${ this.project_id() }` )
			return project
		}

		@ $mol_mem
		session_context() {
			return $mol_wire_sync( $shm_projects_goal_api ).session_context( this.project_id() )
		}

		session_directory() {
			return this.session_context().cwd
		}

		session_agents() {
			return this.session_context().files.join( '\n' ) || 'Нет'
		}

		config_uri() {
			return this.$.$shm_projects_config.resource_url( `${ this.project().directory }/_shm_project.json`, true )
		}

		@ $mol_mem
		config_data( next?: Record< string, any > ) {
			if( next !== undefined ) return next
			return JSON.parse( this.$.$mol_fetch.text( this.config_uri() ) ) as Record< string, any >
		}

		node_key( path: readonly ( string | number )[] ) {
			return JSON.stringify( path )
		}

		node_path( key: string ) {
			return JSON.parse( key ) as ( string | number )[]
		}

		node_value( key: string ) {
			let value: any = this.config_data()
			for( const part of this.node_path( key ) ) value = value?.[ part ]
			return value
		}

		node_set( key: string, value: any ) {
			const data = JSON.parse( JSON.stringify( this.config_data() ) ) as Record< string, any >
			const path = this.node_path( key )
			let host: any = data
			for( const part of path.slice( 0, -1 ) ) host = host[ part ]
			host[ path[ path.length - 1 ] ] = value
			this.config_data( data )
			return value
		}

		node_roots() {
			return Object.keys( this.config_data() ).map( key => this.node_key([ key ]) )
		}

		node_group( key: string ) {
			const value = this.node_value( key )
			if( !value || typeof value !== 'object' ) return false
			return !Array.isArray( value ) || value.some( item => item && typeof item === 'object' )
		}

		node_children( key: string ) {
			if( !this.node_group( key ) ) return []
			const value = this.node_value( key )
			const path = this.node_path( key )
			return Object.keys( value ).map( part => this.node_key([ ...path, Array.isArray( value ) ? Number( part ) : part ]) )
		}

		node_expanded_default( key: string ) {
			return this.node_path( key ).length < 2
		}

		node_expanded_key( key: string ) {
			return `$shm_projects_configuration:${ this.project_id() }:expanded:${ key }`
		}

		node_label( key: string ) {
			const path = this.node_path( key )
			const part = path[ path.length - 1 ]
			return typeof part === 'number' ? `Элемент ${ part + 1 }` : part
		}

		node_content( key: string ) {
			if( this.node_group( key ) ) return [ this.Node_title( key ) ]
			const value = this.node_value( key )
			if( Array.isArray( value ) ) return [ this.List_field( key ) ]
			if( typeof value === 'boolean' ) return [ this.Boolean( key ) ]
			if( typeof value === 'number' ) return [ this.Number_field( key ) ]
			return [ this.Text_field( key ) ]
		}

		node_string( key: string, next?: string ) {
			if( next !== undefined ) return this.node_set( key, next )
			const value = this.node_value( key )
			return value == null ? '' : String( value )
		}

		node_number( key: string, next?: number ) {
			if( next !== undefined ) return this.node_set( key, next )
			return Number( this.node_value( key ) ?? 0 )
		}

		node_boolean( key: string, next?: boolean ) {
			if( next !== undefined ) return this.node_set( key, next )
			return Boolean( this.node_value( key ) )
		}

		@ $mol_mem_key
		node_list( key: string, next?: string ) {
			const current = this.node_value( key ) as any[]
			if( next !== undefined ) return next
			return current.map( value => String( value ?? '' ) ).join( '\n' )
		}

		node_list_values( key: string ) {
			const current = this.node_value( key ) as any[]
			const sample = current.find( value => value != null )
			return this.node_list( key ).split( /\r?\n/ ).map( value => value.trim() ).filter( Boolean ).map( value => {
				if( typeof sample === 'number' ) return Number( value )
				if( typeof sample === 'boolean' ) return value === 'true'
				return value
			} )
		}

		config_data_for_save() {
			const data = JSON.parse( JSON.stringify( this.config_data() ) ) as Record< string, any >
			const apply = ( value: any, path: ( string | number )[] )=> {
				const key = this.node_key( path )
				if( Array.isArray( value ) && !this.node_group( key ) ) {
					let host: any = data
					for( const part of path.slice( 0, -1 ) ) host = host[ part ]
					host[ path[ path.length - 1 ] ] = this.node_list_values( key )
					return
				}
				if( !value || typeof value !== 'object' ) return
				for( const part of Object.keys( value ) ) {
					apply( value[ part ], [ ...path, Array.isArray( value ) ? Number( part ) : part ] )
				}
			}
			for( const part of Object.keys( data ) ) apply( data[ part ], [ part ] )
			return data
		}

		@ $mol_action
		override save( next?: Event ) {
			if( next === undefined ) return null
			const saved = $mol_wire_sync( $shm_projects_goal_api ).project_config_update(
				this.project_id(),
				JSON.stringify( this.config_data_for_save(), null, '\t' ),
			)
			this.$.$shm_projects_data.records_sync( saved.projects )
			this.$.$shm_projects_data.detail_sync( saved.project )
			this.config_data( JSON.parse( saved.config ) )
			return next
		}

	}

}
